import React from 'react'
import Tag, { TagTypeWithStyle } from '../Tag'
import cn from 'classnames'
import { Calendar } from '../Icons'

export type ArticleFeatureProps = {
  title: string
  text: {
    html: string
  }
  image: {
    alt: string
    url: string
  }
  tag?: string | string[]
  tagType?: TagTypeWithStyle
  smallerImage?: boolean
  date?: string
  onRenderImage?: () => JSX.Element
}

// This component is quite similar to PostFeature on Inspired by Iceland
// this it shares many of it's classes
// TODO: create a single component which handles variations

const ArticleFeature = ({
  title,
  text,
  image,
  tag,
  tagType,
  smallerImage = false,
  date,
  onRenderImage
}: ArticleFeatureProps) => {
  return (
    <div className='post-feature d-flex flex-column flex-lg-row my-3 my-4 text-lg-left text-center'>
      {/* Image */}
      <div
        className={cn('position-relative mr-lg-3 p-0', { 'col-lg-5': !smallerImage, 'col-lg-4': smallerImage })}
      >
        <div className='position-relative overflow-hidden image-rounded post-feature__image'>
          {onRenderImage ? onRenderImage() : <img className='h-100 w-100' src={image.url} alt={image.alt} />}
        </div>
      </div>

      <div
        className={cn({
          'pt-lg-3 justify-content-lg-start justify-content-center': !smallerImage,
          'pt-lg-1': smallerImage
        })}
      >
        {/* Date */}
        {date && (
          <div className='d-block d-lg-inline-block'>
            <Calendar />
            <span className='tag--not-clickable tag-bg tag-bg--transparent ml-1'>{date}</span>
          </div>
        )}
        {/* Tags */}
        {tag &&
          (Array.isArray(tag) ? (
            tag.map((t, key) => (
              <Tag key={key} type={tagType} className='tag--not-clickable tag-bg--neutral d-inline-block'>
                {t}
              </Tag>
            ))
          ) : (
            <Tag type={tagType} className='tag--not-clickable tag-bg--neutral d-inline-block'>
              {tag}
            </Tag>
          ))}
        {/* Title */}
        <h3 className='post-feature__title mt-2'>
          <span>{title}</span>
        </h3>
        <div dangerouslySetInnerHTML={{ __html: text.html }} />
      </div>
    </div>
  )
}

export default ArticleFeature
